/*
 * @Author: bz2021
 * @Date: 2025-07-01 17:21:03
 * @Description:  
 */
import axios from 'axios';

const request = axios.create({
  //baseURL: 'http://162.216.240.151:5002/',
  baseURL: 'https://test4.supercaja.net/',
   //baseURL: 'http://127.0.0.1:5002/',
  //baseURL: 'http://162.216.240.151:5002/',
  //baseURL: 'http://localhost:5002/',
  timeout: 5000
});

request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    const publicPaths = [
      '/auth', 
      '/register',
      '/master', 
      '/send_verify_code',
      '/send_reset_verify_code',
      '/reset_password',
      '/proxy',
    ];
    if (token && !publicPaths.some(path => config.url?.includes(path))) {
      config.headers.Authorization = token;
    }
    return config;
  },
  error => Promise.reject(error)
);

request.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response 
        && error.response.status === 401
        && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('username');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default request;
